import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import leftArrow from '../../assets/images/profile/left-arrow-blue.png';
import rbbIcon from '../../assets/images/store/rbb.png';
import postbankIcon from '../../assets/images/store/postbank.png';
import printIcon from '../../assets/images/store/print.png';

import '../../assets/css/store.css';
import Api from '../../__helpers/api';


function Index(props) {

    let orderId = props.match.params.id;
    let bank = new URLSearchParams(window.location.search).get('bank');

    const [data, setData] = useState({
        info: {},
        bank: 'postbank'
    });

    const print = new URLSearchParams(window.location.search).get('print');

    useEffect(() => {

        if (bank !== 'rbb') {
            bank = 'postbank';
        }

        Api.get(`/store/bank-info/?id=${orderId}`)
            .then(res => {
                setData(data => ({ ...data, info: res.data, bank: bank }));
            });

        if (print) {
            document.getElementsByTagName('header')[0].style.display = 'none';
            document.getElementsByTagName('footer')[0].style.display = 'none';
            document.getElementById('storeBanner').style.display = 'none';
            document.getElementsByClassName('select-bank')[0].style.display = 'none';
            const btns = document.querySelectorAll('.buttons');

            btns.forEach(el => {
                el.style.display = 'none';
            });
        }

    }, []);

    const handleBank = name => {

        props.history.push(`?bank=${name}`);

        setData(data => ({
            ...data,
            bank: name
        }));
    }

    const handlePrint = () => {
        const w = window.open(window.location + (window.location.search.indexOf('?') > -1 ? '&' : '?') + 'print=1');

        w.focus();

        setTimeout(() => {
            w.print();
        }, 1000);
    }

    return (
        <main className="show-payment">
            <section id="storeBanner"></section>
            <section id="store">
                <div className="wrapper">
                    <div className="bank-info">
                        <div className="select-bank">
                            <div className="bank">
                                <input type="radio" name="bank" id="postbank" onClick={() => handleBank('postbank')} checked={data.bank === 'postbank' ? true : false} />
                                <img src={postbankIcon} />
                                <label for="postbank" onClick={() => handleBank('postbank')}>Пощенска банка</label>
                            </div>
                            <div className="bank">
                                <input type="radio" name="bank" id="rbb" onClick={() => handleBank('rbb')} checked={data.bank === 'rbb' ? true : false} />
                                <img src={rbbIcon} />
                                <label for="rbb" onClick={() => handleBank('rbb')}>Райфайзен банк</label>
                            </div>
                        </div>

                        <div id="print-info" className="table">
                            <div className="row">
                                <div className="col">
                                    <div className="title">Име на получателя</div>
                                    <div className="content">{data.info.provider}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-1">
                                    <div className="title">IBAN на получателя</div>
                                    <div className="content">{data.info.banks ? data.info.banks[data.bank].iban : ''}</div>
                                </div>
                                <div className="col col-2">
                                    <div className="title">BIC</div>
                                    <div className="content">{data.info.banks ? data.info.banks[data.bank].bic : ''}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="title">Банка на получателя</div>
                                    <div className="content">{data.info.banks ? data.info.banks[data.bank].name : ''}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-1">
                                    <div className="title">Валута</div>
                                    <div className="content">BGN</div>
                                </div>
                                <div className="col col-2">
                                    <div className="title">Цена</div>
                                    <div className="content">{data.info.gross_price}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="title">Основание за плащане</div>
                                    <div className="content">{data.info.description}</div>
                                </div>
                            </div>
                        </div>

                        <div className="buttons">

                            <Button className="back">
                                <Link to="/store">
                                    <img src={leftArrow} />
                                    Назад
                                    </Link>
                            </Button>


                            <Button className="print" onClick={handlePrint}>
                                <img src={printIcon} />
                                Принтиране
                            </Button>

                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Index;